module.exports = __webpack_public_path__ + "static/media/BLungInfectionClinic.090775c9.png";